// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { getAllCrfProjetoRelatorioRpp } from '@app/api/crf/crfProjeto';
import {
  CrfTabelaProjetoOverViewResult,
  getAllCrfProjetoOverView
} from '@app/api/crf/crftabelaProjetoOverView';

//Files
import CrfProjetoOverView from './crfProjetoOverView';
import CrfTabelaProjetoOverviewResumo from '../../Dashboard/ProjectsOverview/tabelaProjetoOverviewResumo';

const CrfRelatorioProjectsOverview = () => {
  const [projetos, setProjetos] = useState(() => getAllCrfProjetoRelatorioRpp);
  const [resultProjetoOverView, setResultProjetoOverView] = useState<CrfTabelaProjetoOverViewResult[]>();
  const idTodos = '00000000-0000-0000-0000-000000000000';
  const urlTodosProjeto =
    '/relatorioProjectsOverview/detail/00000000-0000-0000-0000-000000000000/detalhe';
  const idAbaGeral = 'dadosGerais';

  const getValueUrl = () => {
    const latUrl = window.location.pathname.split('/').pop();
    if (latUrl === idAbaGeral) {
      const ulr = window.location.origin;
      const urlFinal = `${ulr}${urlTodosProjeto}`;
      window.location.href = urlFinal;
    }
  };

  useEffect(() => {
    getAllCrfProjetoOverView().then((data) => {
      if (data)
        setResultProjetoOverView(data);
    });
  }, [])

  return (
    <ui.CrudMasterDetailView
      getAllItems={projetos}
      filterPredicate={(item, value) =>
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        (item.numero && item.numero.toLowerCase().includes(value.toLowerCase())) ||
        item.nome.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => (item.id === idTodos ? `${item.nome}` : `${item.codigo} - ${item.nome}`)}
      descriptionExtractor={item => item.statusNome || ''}>
      <ui.CrudContext.Consumer>
        {({ selectedItem }) => {
          if (selectedItem && selectedItem.id === idTodos) {
            getValueUrl();
            return (
              <ui.CompositeView>
                {selectedItem ? (
                  <ui.GridView icon="files-new_by_copy" id={`detalhe`} noform title="PROJECTS | APPROVED">
                    <CrfTabelaProjetoOverviewResumo
                      dataSourceResult={resultProjetoOverView}
                      telaFechamento={false}
                    />
                  </ui.GridView>
                ) : (
                  () => { }
                )}
              </ui.CompositeView>
            );
          } else {
            return (
              <ui.CompositeView>
                {selectedItem ? (
                  <ui.GridView icon="files-new_by_copy" id={`detalhe`} noform title="DADOS GERAIS">
                    <CrfProjetoOverView selectedItem={selectedItem} />
                  </ui.GridView>
                ) : (
                  () => { }
                )}
              </ui.CompositeView>
            );
          }
        }}
      </ui.CrudContext.Consumer>
    </ui.CrudMasterDetailView>
  );
};

export default CrfRelatorioProjectsOverview;
